document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".btn-scroll-top");

  // Функція для перевірки прокрутки
  const checkScroll = () => {
    if (window.scrollY > window.innerHeight * 0.2) {
      btn.style.display = "flex"; // Показуємо кнопку, якщо прокрутка більше 20%
    } else {
      btn.style.display = "none"; // Ховаємо кнопку, якщо прокрутка менше 20%
    }
  };

  // Перевіряємо прокрутку при завантаженні сторінки
  checkScroll();

  // Обробник події для прокручування
  window.addEventListener("scroll", checkScroll);

  // Обробник події для натискання на кнопку
  btn.addEventListener("click", () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });
});
